export const stripHtml = (html = '') => {
    const doc = new DOMParser().parseFromString(
      html,
      'text/html'
    );
  
    return doc.body.textContent || '';
  };
  
  export const formatDate = (dateString) => {
    if (!dateString) return '';
  
    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    }).format(new Date(dateString));
  };
  
  export const generateSlug = (title = '') => {
    return title
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)+/g, '');
  };
  
  export const getExcerpt = (content, length = 160) => {
    const text = stripHtml(content);
  
    if (text.length <= length) {
      return text;
    }
  
    return `${text.substring(0, length)}...`;
  };
  
  export const getArticleImage = (article) => {
    if (article.thumbnail) {
      return article.thumbnail;
    }
  
    const content = article.description || '';
  
    const match = content.match(
      /<img[^>]+src="?([^"\s]+)"?\s*\/?>/i
    );
  
    return match?.[1] || null;
  };
  